import React, { useRef, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import { Navigation, Snackbar } from 'common';
import Form from './form';
import ParsedResume from './parsedResume';
import { useSelector } from 'react-redux';
import SrPageBanner from 'core/srPageBanner/srPageBanner';
import { IMG_MAN_WORKING } from 'images';

const useStyles = makeStyles(() => ({
  container: {
    padding: 24,
    background: '#fbfbfb',
    position: 'relative',
    marginTop: 26,
    minHeight: 'calc(100vh - 48px)',
    alignContent: 'flex-start',
  },
  bannerClass: {
    marginTop: 24,

    '& div': {
      maxWidth: 600,
    },
  },
  rightContent: {
    paddingLeft: 25,
  },
}));

const ResumeParser = () => {
  const classes = useStyles();
  const [parsedResume, setParsedResume] = useState(null);
  const [isParsing, setIsParsing] = useState(false);
  const bannerRef = useRef(null);
  const {
    ResumeParserFileTypeError,
    ResumeParserMultipleFilesError,
    ResumeParserError,
  } = useSelector((state) => state.flags);

  const updateCredits = () => {
    if (bannerRef.current) {
      bannerRef.current.getCreditCount();
    }
  };

  return (
    <>
      <Navigation />
      <Grid container classes={{ root: classes.container }}>
        <Grid container classes={{ root: classes.contentContainer }}>
          <Form
            setParsedResume={setParsedResume}
            parsedResume={parsedResume}
            isParsing={isParsing}
            setIsParsing={setIsParsing}
            updateCredits={updateCredits}
          />
          <Grid item xs={7} classes={{ root: classes.rightContent }}>
            <SrPageBanner
              title="Resume Parser"
              subTitle="Combining NLP and Vision to accurately extract details from resumes. Parse with ultra high accuracy, all types of resumes, those with different layouts, multiple columns, with logos, images, or scanned copies."
              image={IMG_MAN_WORKING}
              containerClass={classes.bannerClass}
              planId="61a073808ca97177a690ed74"
              apiLink="https://docs.senseloaf.ai/#tag/Resume-parser"
              bannerRef={bannerRef}
            />
            <ParsedResume
              resume={
                parsedResume && parsedResume.json ? parsedResume.json : null
              }
              isParsing={isParsing}
            />
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={!!ResumeParserError}
        message={ResumeParserError}
        flag="ResumeParserError"
      />

      <Snackbar
        open={ResumeParserFileTypeError}
        message={'Accepts pdf, doc, docx, jpg, jpeg, png'}
        flag="ResumeParserFileTypeError"
      />
      <Snackbar
        open={ResumeParserMultipleFilesError}
        message={'Multiple Files are not allowed for Resume'}
        flag="ResumeParserMultipleFilesError"
      />
    </>
  );
};

export default ResumeParser;
